import styled, { css } from 'styled-components';
import { getSpace } from '../../../foundation/theme/space.utils';
// styled-components.
// -----------------------------------------------------------------------------
export const ToastContainer = styled.div `
  ${({ position }) => {
    return css `
      // Box.
      display: flex;
      flex-direction: column;
      gap: ${getSpace('l')};

      ${position === 'bottom-center' && `align-items: center;`}
      ${position === 'bottom-right' && `align-items: flex-end;`}
      ${position === 'top-center' && `align-items: center;`}
      ${position === 'top-right' && `align-items: flex-end;`}
    `;
}}
`;
export const ToastRoot = styled.div `
  ${({ position }) => {
    return css `
      // Box.
      position: fixed;

      // Space
      margin: ${getSpace('s')};

      // Conditional rules.
      ${position === 'bottom-center' &&
        `bottom: 0; left: 50%; transform: translateX(-50%);`}
      ${position === 'bottom-left' && `bottom: 0; left: 0;`}
      ${position === 'bottom-right' && `bottom: 0; right: 0;`}

      ${position === 'top-center' &&
        `top: 0; left: 50%; transform: translateX(-50%);`}
      ${position === 'top-right' && `top: 0; right: 0;`}
      ${position === 'top-left' && `top: 0; left: 0;`}
    `;
}}
`;
//# sourceMappingURL=Toast.styled.js.map